import { pathJoin } from 'src/reducers/routing/utils'

export const createRouteMapVehicle = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  driver: pathJoin(prefix)('vehicle').chain,
  route: pathJoin(prefix)('route').chain,
  'service-log': pathJoin(prefix)('service-log').chain,
  'vehicle-planner': pathJoin(prefix)('vehicle-planner').chain,
})
